import { Pipe, PipeTransform, inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Leistungseinheit } from '../../domain/model/leistungseinheit';

@Pipe({
    name: 'leistungseinheit',
    standalone: false,
})
export class LeistungseinheitPipe implements PipeTransform {
    private decimalPipe = inject(DecimalPipe);

    transform(valueInKw: number, leistungseinheit: Leistungseinheit = Leistungseinheit.KW): string {
        let value = valueInKw || 0;
        let prefix = '';
        switch (leistungseinheit) {
            case Leistungseinheit.KW:
                prefix = 'kW';
                break;
            case Leistungseinheit.MW:
                value /= 1000;
                prefix = 'MW';
                break;
        }
        return this.decimalPipe.transform(value, '1.2-2', 'de') + ` ${prefix}`;
    }
}
